export default
    {
        path: "/discovery",
        component: () => import('../view/discovery/news/discoveryMain.vue'),
        children: [
            {
                path: 'newsList',
                component: () => import('../view/discovery/news/NewsInfoList.vue'),
                props: (route) => (
                    {
                        token:route.query.token,
                        koaToken:route.query.koaToken,
                        userId:route.query.userId,
                        deviceType:route.query.deviceType,
                        secondLoginType:route.query.secondLoginType,
                        secondAssessToken:route.query.secondAssessToken,
                        deviceId:route.query.deviceId,
                        
                    }
                ),
                children:[
                    {
                        path: 'newsDetail',
                        component: () => import('../view/discovery/news/NewsInfoDetail.vue'),
                        props: (route) => (
                            {       
                                token:route.query.token,     
                                newsId:route.query.newsId,
                                publisPerson:route.query.publisPerson,
                                watchTimes:route.query.watchTimes,
                                discussTimes:route.query.discussTimes,
                                newsTitle:route.query.newsTitle,
                                publishTime:route.query.publishTime,
                                userId:route.query.userId,
                                koaToken:route.query.koaToken,
                                deviceType:route.query.deviceType,
                                secondLoginType:route.query.secondLoginType,
                                secondAssessToken:route.query.secondAssessToken,
                                deviceId:route.query.deviceId,
        
                            }
                        ),
                        children:[
                            {
                                path: 'newsDetailDiscuss',
                                component: () => import('../view/discovery/news/NewsInfoDetailDiscuss.vue'),
                                props: (route) => (
                                    {       
                                        token:route.query.token,     
                                        newsId:route.query.newsId,
                                        publisPerson:route.query.publisPerson,
                                        watchTimes:route.query.watchTimes,
                                        discussTimes:route.query.discussTimes,
                                        newsTitle:route.query.newsTitle,
                                        publishTime:route.query.publishTime,
                                        userId:route.query.userId,
                
                                    }
                                )
                            }
                        ]
                    },
                    {
                        path: 'newsDetailDiscuss',
                        component: () => import('../view/discovery/news/NewsInfoDetailDiscuss.vue'),
                        props: (route) => (
                            {       
                                token:route.query.token,     
                                newsId:route.query.newsId,
                                publisPerson:route.query.publisPerson,
                                watchTimes:route.query.watchTimes,
                                discussTimes:route.query.discussTimes,
                                newsTitle:route.query.newsTitle,
                                publishTime:route.query.publishTime,
                                
                                userId:route.query.userId,
        
                            }
                        )
                    }
                ]
            },
            {
                path: 'newsDetailNative',
                        component: () => import('../view/discovery/news/NewsInfoDetail.vue'),
                        props: (route) => (
                            {       
                                token:route.query.token,     
                                newsId:route.query.newsId,
                                publisPerson:route.query.publisPerson,
                                watchTimes:route.query.watchTimes,
                                discussTimes:route.query.discussTimes,
                                newsTitle:route.query.newsTitle,
                                publishTime:route.query.publishTime,
                                userId:route.query.userId,
                                koaToken:route.query.koaToken,
                                deviceType:route.query.deviceType,
                                secondLoginType:route.query.secondLoginType,
                                secondAssessToken:route.query.secondAssessToken,
                                deviceId:route.query.deviceId,
        
                            }
                        ),
                        children:[
                            {
                                path: 'newsDetailDiscuss',
                                component: () => import('../view/discovery/news/NewsInfoDetailDiscuss.vue'),
                                props: (route) => (
                                    {       
                                        token:route.query.token,     
                                        newsId:route.query.newsId,
                                        publisPerson:route.query.publisPerson,
                                        watchTimes:route.query.watchTimes,
                                        discussTimes:route.query.discussTimes,
                                        newsTitle:route.query.newsTitle,
                                        publishTime:route.query.publishTime,
                                        userId:route.query.userId
                
                                    }
                                )
                            }
                        ]
            },
            {
                path: 'newsDetailDiscuss',
                component: () => import('../view/discovery/news/NewsInfoDetailDiscuss.vue'),
                props: (route) => (
                    {       
                        token:route.query.token,     
                        newsId:route.query.newsId,
                        publisPerson:route.query.publisPerson,
                        watchTimes:route.query.watchTimes,
                        discussTimes:route.query.discussTimes,
                        newsTitle:route.query.newsTitle,
                        publishTime:route.query.publishTime,
                        userId:route.query.userId,
                        secondLoginType:route.query.secondLoginType,
                        secondAssessToken:route.query.secondAssessToken,
                        deviceId:route.query.deviceId,
                        

                    }
                )
            },
            {
                path: 'personMap',
                component: () => import('../view/discovery/personsMap/personMap.vue'),
                props: (route) => (
                    {       
                        token:route.query.token,     
                        newsId:route.query.newsId,
                        publisPerson:route.query.publisPerson,
                        watchTimes:route.query.watchTimes,
                        discussTimes:route.query.discussTimes,
                        newsTitle:route.query.newsTitle,
                        publishTime:route.query.publishTime,
                        userId:route.query.userId,
                        secondLoginType:route.query.secondLoginType,
                        secondAssessToken:route.query.secondAssessToken,
                        deviceId:route.query.deviceId,
                        

                    }
                )
            }
            
        ]

    }



// WEBPACK FOOTER //
// ./src/router/discoveryRouter.js